import { SERVICES } from "@/data/site";
import { SEO } from "@/components/SEO";
import { ServiceCard } from "@/components/ServiceCard";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CTABanner } from "@/components/CTABanner";

export default function Servicos() {
  return (
    <>
      <SEO
        title="Serviços de Desentupimento em São Paulo | Paulistana"
        description="Conheça nossos serviços: desentupimento de pia, vaso sanitário, esgoto, hidrojateamento, limpeza de caixa de gordura e ralos. Atendimento 24h nos bairros nobres de SP."
        path="/servicos"
      />
      <section className="bg-brand-black text-white">
        <div className="max-w-7xl mx-auto container-px py-14">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Serviços" }]} />
          <h1 className="font-display font-black text-4xl sm:text-5xl mt-4 mb-3">Nossos Serviços</h1>
          <p className="text-gray-300 max-w-2xl">Soluções completas de desentupimento e limpeza de tubulações, com equipamentos profissionais e atendimento de emergência 24 horas.</p>
        </div>
      </section>
      <section className="bg-white">
        <div className="max-w-7xl mx-auto container-px py-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => (
            <ServiceCard key={s.slug} service={s} />
          ))}
        </div>
      </section>
      <CTABanner />
    </>
  );
}
